class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
          const cartDrawerItems = this.querySelector('cart-drawer-items');
    if (cartDrawerItems) {
      cartDrawerItems.updateCartUpsellToggleState();
      cartDrawerItems.updateCartUpsellVisibility();
    }

    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement || !parsedState.sections || !parsedState.sections[section.id]) return;
      const html = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if (html) sectionElement.innerHTML = html;
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

(function bindCartDrawerKpopBundle() {
  if (window.__kpopCartDrawerBound) return;
  window.__kpopCartDrawerBound = true;

  const jsonHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  };

  function jsUrl(route, fallback) {
    const value = route || fallback;
    if (!value) return fallback;
    return value.endsWith('.js') ? value : `${value}.js`;
  }

  function addUrl() {
    return jsUrl(window.routes && window.routes.cart_add_url, '/cart/add.js');
  }

  function changeUrl() {
    return jsUrl(window.routes && window.routes.cart_change_url, '/cart/change.js');
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function parseJson(res) {
    return res.json().then((json) => {
      if (!res.ok || json.status) return Promise.reject(json);
      return json;
    });
  }

  function postCart(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(body),
    }).then(parseJson);
  }

  function replaceDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return Promise.resolve();

    return Promise.all([
      fetch(`${cartUrl()}?section_id=cart-drawer`).then((res) => res.text()),
      fetch(`${cartUrl()}?section_id=cart-icon-bubble`).then((res) => res.text()),
      fetch(`${cartUrl()}.js`).then((res) => res.json()),
    ]).then(([drawerText, bubbleText, cart]) => {
      const drawerDoc = new DOMParser().parseFromString(drawerText, 'text/html');
      const bubbleDoc = new DOMParser().parseFromString(bubbleText, 'text/html');
      const newInner = drawerDoc.querySelector('.drawer__inner');
      const currentInner = cartDrawer.querySelector('.drawer__inner');
      if (newInner && currentInner) currentInner.replaceWith(newInner);

      const currentBubble = document.getElementById('cart-icon-bubble');
      const newBubble = bubbleDoc.getElementById('cart-icon-bubble');
      if (currentBubble && newBubble) currentBubble.innerHTML = newBubble.innerHTML;

      cartDrawer.classList.toggle('is-empty', !cart.item_count);
      const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
      cartDrawer.open();
    });
  }

  document.addEventListener('click', (event) => {
    const chip = event.target.closest('.cdkb-chip');
    if (chip) {
      event.preventDefault();
      const container = chip.closest('.cart-drawer-kpop-bundle');
      if (!container) return;
      container.querySelectorAll('.cdkb-chip').forEach((el) => el.classList.remove('is-active'));
      chip.classList.add('is-active');
      const thumb = container.querySelector('[id^="CdkbCompanionThumb-"]');
      if (thumb && chip.dataset.img) thumb.src = chip.dataset.img;
      return;
    }

    const addBtn = event.target.closest('.cdkb-btn');
    if (!addBtn) return;
    event.preventDefault();
    event.stopPropagation();

    const container = addBtn.closest('.cart-drawer-kpop-bundle');
    if (!container || addBtn.disabled) return;

    const activeChip = container.querySelector('.cdkb-chip.is-active');
    const variantId = activeChip && Number(activeChip.dataset.variantId);
    if (!variantId) return;

    const textSpan = addBtn.querySelector('.cdkb-btn-text');
    const loaderSpan = addBtn.querySelector('.cdkb-btn-loader');
    const kitKey = container.dataset.kitKey;

    addBtn.disabled = true;
    if (textSpan) textSpan.style.display = 'none';
    if (loaderSpan) loaderSpan.style.display = 'inline-block';

    const addBundle = () =>
      postCart(addUrl(), {
        items: [{ id: variantId, quantity: 1 }],
      });

    const swapKitThenAdd = kitKey
      ? postCart(changeUrl(), { id: kitKey, quantity: 0 }).then(addBundle)
      : addBundle();

    swapKitThenAdd
      .then(replaceDrawer)
      .catch((err) => {
        console.error('Cart drawer add-both error:', err);
        addBtn.disabled = false;
        if (textSpan) textSpan.style.display = 'inline-block';
        if (loaderSpan) loaderSpan.style.display = 'none';
        alert('Could not add the bundle to cart. Please try again.');
      });
  });
})();

